/* ============================================================
   tio-hero.js — carga condicional del video del hero (PF-03).

   REGLA DURA: solo puede descargarse UNO de los dos videos.
   Por eso el <video> llega del servidor sin src y sin <source>: aca se
   decide con matchMedia cual corresponde y recien entonces se asigna.
   Nada empieza a bajar antes de esa decision.

   Prohibido (y no se usa): el atributo media en <source>, que los
   navegadores dejaron de soportar, y dos <video> con display:none, que
   no impide que el oculto se descargue igual.

   Si algo de esto falla, el hero NO se rompe: el poster es un <img> real
   puesto por Liquid y el video solo se muestra cuando reproduce.
   ============================================================ */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 768px)';

  function montar(media) {
    if (!media || media.hasAttribute('data-tio-hero-listo')) return;

    var video = media.querySelector('[data-tio-hero-video]');
    var poster = media.querySelector('.home-heroC__poster');
    var esDesktop = window.matchMedia(DESKTOP).matches;

    /* El poster server-side es el de movil. En desktop se cambia ANTES de
       tocar el video, para que el LCP sea el correcto en cada formato. */
    var posterDesktop = media.getAttribute('data-poster-desktop');
    if (esDesktop && poster && posterDesktop) {
      poster.removeAttribute('srcset');
      poster.removeAttribute('sizes');
      poster.src = posterDesktop;
    }

    if (!video) return;

    var src = esDesktop
      ? media.getAttribute('data-video-desktop')
      : media.getAttribute('data-video-movil');

    /* Si falta el archivo del formato actual se usa el otro: mejor un
       video reencuadrado que ninguno. Si no hay ninguno, queda el poster. */
    if (!src) {
      src = esDesktop
        ? media.getAttribute('data-video-movil')
        : media.getAttribute('data-video-desktop');
    }
    if (!src) return;

    media.setAttribute('data-tio-hero-listo', '1');

    /* El video se revela SOLO cuando esta reproduciendo de verdad. Con el
       autoplay bloqueado (iOS en Bajo Consumo) esto nunca ocurre y el
       usuario se queda con el poster, que es exactamente lo esperado. */
    video.addEventListener('playing', function () {
      video.classList.add('is-playing');
    });

    video.src = src;

    var intento = video.play();
    if (intento && typeof intento.catch === 'function') {
      intento.catch(function () {
        /* Autoplay bloqueado. No es un error: el poster cubre el hero. */
      });
    }
  }

  function iniciar() {
    var medias = document.querySelectorAll('[data-tio-hero-media]');
    for (var i = 0; i < medias.length; i++) montar(medias[i]);

    /* Entrada escalonada del copy. data-anim NO viene del servidor: si el
       JS no corre, nada queda en opacity:0 y el hero se ve entero
       (doctrina anti-flash C4 §7). */
    var heros = document.querySelectorAll('[data-tio-hero]');
    for (var j = 0; j < heros.length; j++) heros[j].setAttribute('data-anim', '1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* El editor de temas re-renderiza la section al cambiar un setting. */
  document.addEventListener('shopify:section:load', iniciar);
})();
